/** Отправитель игровых push/inbox-уведомлений («Хранители»). */
export const GAME_NOTIFY_FROM = "Хранители"
